import { useCallback, useEffect, useState } from "react";

import {
  type DashboardAdminOrganization,
  listOrganizationsForAdminAsAdmin,
} from "../dashboard-client";

interface UseAdminState {
  organizations: DashboardAdminOrganization[];
  loading: boolean;
  error: string | null;
}

export function useAdmin() {
  const [state, setState] = useState<UseAdminState>({
    error: null,
    loading: false,
    organizations: [],
  });

  const refresh = useCallback(async () => {
    setState((s) => ({ ...s, error: null, loading: true }));
    try {
      const { data } = await listOrganizationsForAdminAsAdmin({});
      const { organizations } = data;
      setState({ error: null, loading: false, organizations });
    } catch (error) {
      setState((s) => ({
        ...s,
        error:
          error instanceof Error
            ? error.message
            : "Failed to load organizations",
        loading: false,
      }));
    }
  }, []);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  return {
    error: state.error,
    loading: state.loading,
    organizations: state.organizations,
    refresh,
  };
}
